import { CONTENT } from "./content";

/**
 * The four ALPS pillars, read out of the approved method copy
 * ("ALPS significa Ascolta, Leggi, Parla, Scrivi.") rather than hard-coded,
 * so the brand signature always matches the content.
 */
export const readAlpsPillars = () => {
  const segment = CONTENT.offerings.description.find(
    (item) => typeof item.content === "string" && /Ascolta/i.test(item.content)
  );
  if (!segment) return [];
  return segment.content
    .replace(/\.\s*$/, "")
    .split(",")
    .map((word) => word.trim())
    .filter(Boolean);
};
